import React from 'react'

const Tips = () => {
  return (
    <svg
      fill='none'
      viewBox='0 0 25 26'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M19.5 20a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5zM18 24.5h6a4.64 4.64 0 00-6.8-2.881M5.5 20a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5zM6.969 24.5H1a4.64 4.64 0 016.77-2.9M8.257 9.257a6 6 0 018.486 0M6.136 7.136a9 9 0 0112.728 0'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4.015 5.015a12 12 0 0116.97 0M18 24.5a5.5 5.5 0 00-11 0h11z'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
      <path
        d='M9.644 12.6a5.4 5.4 0 006.021 1.21M12.444 17.5a3.25 3.25 0 100-6.5 3.25 3.25 0 000 6.5z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default Tips
